import { render } from "./ShoppingCarDetails.vue?vue&type=template&id=ef1dae02&scoped=true"
import script from "./ShoppingCarDetails.vue?vue&type=script&lang=js"
export * from "./ShoppingCarDetails.vue?vue&type=script&lang=js"

import "./ShoppingCarDetails.vue?vue&type=style&index=0&id=ef1dae02&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\comprodonto_site_v4\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef1dae02"]])

export default __exports__